export default __webpack_public_path__ + "static/media/accenture-3.314419f4.svg";